import type {ConverterAdFeat} from './ConverterExportDialog'

const iconStrokeProps = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.75,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
}

/** Shared 3-bullet "also need App Store screenshots?" ad pitch used by every
 * converter tool's export dialog (image converter, video-to-gif) — same icon
 * set as the icon/qr-generator dialogs' pitch, extracted here since it was
 * about to be duplicated a third time. */
export const CONVERTER_AD_FEATS: ConverterAdFeat[] = [
  {
    key: 'mockup',
    icon: (
      <svg {...iconStrokeProps}>
        <rect x="6" y="2" width="12" height="20" rx="2.5" />
        <path d="M11 18h2" />
      </svg>
    ),
  },
  {
    key: 'carousel',
    icon: (
      <svg {...iconStrokeProps}>
        <rect x="2" y="5" width="6" height="14" rx="1.2" />
        <rect x="9" y="5" width="6" height="14" rx="1.2" />
        <rect x="16" y="5" width="6" height="14" rx="1.2" />
      </svg>
    ),
  },
  {
    key: 'free',
    icon: (
      <svg {...iconStrokeProps}>
        <path d="M20.6 13.4l-7.2 7.2a2 2 0 01-2.8 0L3 12.8V4h8.8l8.8 8.8a2 2 0 010 2.6z" />
        <circle cx="8.5" cy="8.5" r="1.3" />
      </svg>
    ),
  },
]
